<template>
  <main>
    <menus class="menus"/>
    <section class="user_info">
      <header>
        <figure>
          <div class="img">
            <img :src="userInfo.avatarUrl" alt="">
            <span>{{ userInfo.identify_text }}</span>
          </div>
          <p>
            <b>{{ userInfo.contact_name }}</b>
            <span>手机号码：{{ userInfo.customerMobile }}</span>
          </p>
        </figure>
        <!-- <div class="wallet">
          <p><span>余额：</span><b>99,999.00</b></p>
          <div class="btn">
            <el-button type="danger">充值</el-button>
            <el-button type="warning">提现</el-button>
          </div>
        </div> -->
      </header>
      <section class="order">
        <h3>订单管理</h3>
        <nav>
          <el-badge :value="order.length" class="option">
            <i class="icon-qianzheng"></i>
            <span>签证订单</span>
          </el-badge>
          <el-badge class="option">
            <i class="icon-jipiao"></i>
            <span>机票订单</span>
          </el-badge>
          <el-badge class="option">
            <i class="icon-icon_xinyong_xianxing_jijin-"></i>
            <span>酒店订单</span>
          </el-badge>
          <el-badge class="option">
            <i class="icon-Route"></i>
            <span>线路订单</span>
          </el-badge>
        </nav>
      </section>
    </section>
  </main>
</template>

<script>
import menus from '@components/menu';
import { mapState } from 'vuex';
export default {
  components: {
    menus
  },
  data () {
    return {
      order: []
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  created () {
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.$axios.get('/VisaOrder/getOrdersByUser').then(res => {
        const { data } = res;
        this.order = data;
      })
    }
  }
}
</script>

<style scoped src="./index.css"></style>